import { Component, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
	selector: 'app-math-calculator',
	styleUrls: ['./math-calculator.component.scss'],
	templateUrl: './math-calculator.component.html'
})
export class MathCalculatorComponent {
	display: string = '0';

	constructor(public activeModal: NgbActiveModal) {}

	/** Gestion des clics sur les boutons **/
	press(value: string) {
		if (this.display === '0' && !isNaN(Number(value))) {
			this.display = value;
		} else {
			if (value === ',') value = '.';
			this.display += value;
		}
	}

	clear() {
		this.display = '0';
	}

	backspace() {
		if (this.display.length > 1) {
			this.display = this.display.slice(0, -1);
		} else {
			this.display = '0';
		}
	}

	calculate() {
		try {
			const expression = this.display.replace(/,/g, '.');
			const result = eval(expression);

			if (isNaN(result) || !isFinite(result)) {
				this.display = 'Error';
				return;
			}

			this.display = parseFloat(result.toFixed(8)).toString();
		} catch {
			this.display = 'Error';
		}
	}

	close() {
		this.activeModal.close();
	}

	/** 🎹 Gestion des touches clavier **/
	@HostListener('window:keydown', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		const key = event.key;

		if (key.match(/[0-9]/)) {
			this.press(key);
		} else if (key === '.') {
			this.press('.');
		} else if (key === ',' || key === ';') {
			this.press(',');
		} else if (['+', '-', '*', '/'].includes(key)) {
			this.press(key);
		} else if (key === '%') {
			this.press('%');
		} else if (key === 'Backspace') {
			this.backspace();
		} else if (key === 'Escape') {
			this.clear();
		} else if (key === 'Enter' || key === '=') {
			event.preventDefault();
			this.calculate();
		}
	}
}
